import Cookies from 'js-cookie'

import { hiMenu } from "@/utils/help";
const app = {
  state: {
    sidebar: {
      opened: 1,
      withoutAnimation: false
    },
    device: 'desktop'
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = true
    },
    CLOSE_SIDEBAR: state => { 
      state.sidebar.opened = false;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR');
      hiMenu(); //隐藏没有阶段的菜单
    },
    CloseSideBar({ commit }) {
     commit('CLOSE_SIDEBAR')
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js